import { render, staticRenderFns } from "./AccountMarket.vue?vue&type=template&id=62ed0ca7&scoped=true&"
import script from "./AccountMarket.vue?vue&type=script&lang=ts&"
export * from "./AccountMarket.vue?vue&type=script&lang=ts&"
import style0 from "./AccountMarket.vue?vue&type=style&index=0&id=62ed0ca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ed0ca7",
  null
  
)

export default component.exports